<style scoped>
#worklist_header {
	font-size: 16px;
	color: black;
	overflow: hidden;
}
</style>

<template>
	<div id="worklist_header">
		<div>
			<span>{{ listtype }}: </span>
			<span><b>{{ worklist.name }}</b></span>
			<span v-if="worklist.is_dynamic">, dynamic</span>
			<span v-if="worklist.is_owned">, your worklist</span>
			<span v-if="!worklist.is_owned && !worklist.owner.is_admin">, {{ worklist.owner.name }}</span>
			<span v-if="!worklist.is_owned && worklist.owner.is_admin">, JobBag</span>
		</div>
		<div>
			<span>Shared with: </span>
			<v-chip
				:active="!worklist.acl"
				class="mr-1"
			>
				Not shared with anyone.
			</v-chip>
			<span v-if="worklist.acl">
				<v-chip 
					:key="acl.usid" 
					v-for="acl in acllist"
					color="grey-lighten-3"
					close pill
					close-icon-not-now="mdi-delete"
					:disabled="!worklist.is_owned"
					class="mr-1"
					@click:close="remove_share(acl.usid)"
				>
					<v-user-avatar
						v-if="acl.usid > 0"
						size="24"
						color="#192a3e"
						:code="acl.name"
						:image="'/api/addressbook/' + acl.adbid + '/image.png'"
						left
					/>
					<span>{{ acl.name }}</span>
				</v-chip>
			</span>
			<v-chip 
				color="#192a3e"
				close
				close-icon="mdi-plus"
				:active="worklist.is_owned"
				class="mr-1 white--text"
				@click="add_share()"
				@click:close="add_share()"
			>
				Share
			</v-chip>
		</div>
		<v-share-dialog
			:worklist="worklist"
			ref="share_dialog"
			@changed_share="acl => $emit('changed_share', acl)"
		/>
	</div>
</template>

<script>
import worklist_share_dialog from "@/components/worklist/share_worklist_dialog"

export default {
	components: {
		'v-share-dialog': worklist_share_dialog
	},
	props: {
		listtype: {
			type: String,
			default: "Worklist"
		},
		worklist: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			acllist: [],
		}
	},
	mounted() {
		this.copy_acl(this.worklist.acl)
	},
	methods: {
		copy_acl(new_acl) {
			this.acllist = [];

			if (new_acl) {
				new_acl.forEach(acl => {
					this.acllist.push({
						usid: acl.usid,
						adbid: acl.adbid,
						name: acl.name,
						imgerror: false
					})
				})				
			}

		},
		add_share() {
			// need to implement this
			this.$refs.share_dialog.open(this.worklist.acl)
		},
		remove_share(usid) {
			let self = this;

			axios
				.put("/api/worklists/" + this.worklist.id + "/shared/" + usid, {
					enabled: false
				}, {
					"Authorization": "Bearer " + self.$store.state.token,
					"Accept": "application/json"				
				})
				.then(function(d) {
					// Don't ask me why it does work here... 
					let json = d.data;

					if (json.status == "OK") {
						// close dialog
						self.visible = false

						// let the world know
						self.$emit('changed_share', json.data);
					} else {
						// self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					// self.errormsg = e.message;
				});
		}
	},
	watch: {
		'worklist.acl': function(new_acl) {
			this.copy_acl(new_acl)
		}
	}
}
</script>